import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import EventManagement from './EventManagement';
import Dashboard from './Dashboard';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFethSize } from '../../services/SystemSettings/SystemSettingsService';
import { setFetchSize } from '../../redux/search.slice';
let tabref: TabComponent = new TabComponent({});
const ControlCenter = () => {
  const reduxEventId = useSelector((state: any) => state.search.event_id);
  const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
  const dispatch = useDispatch();
  let global_fetch_size = useSelector(
    (state: any) => state.search.page_range_from_settings
  );
  let page_range_from_settings: number;

  useEffect(() => {
    if (reduxEventId !== 0) {
      tabref.select(0);
    }
  }, [reduxEventId]);
  const getFetchSize = async () => {
    const model = await getFethSize();
    if (model.data.length === 0) {
      dispatch(setFetchSize(300));
    } else {
      model.data.map((item: any) => {
        if (item.isChecked === true) {
          page_range_from_settings = item.fetch_size;
        }
      });
      dispatch(setFetchSize(page_range_from_settings));
    }
  };

  useEffect(() => {
    getFetchSize();
    var now = new Date();
    var utc = now.getTimezoneOffset() / 60;
    if (ERP_TYPE === 'PRONTO') {
      utc = -10;
    }
    localStorage.setItem('tzDrawer', `Etc/GMT${utc}`);
  }, []);
  return (
    <TabComponent
      id='control-center-tab'
      ref={(ref: TabComponent) => (tabref = ref)}
      heightAdjustMode='Auto'
      statelessTemplates={['directiveTemplates']}
    >
      <TabItemsDirective>
        <TabItemDirective
          header={{ text: 'Event Management' }}
          content={() => <EventManagement />}
        />
        <TabItemDirective
          header={{ text: 'Dashboard' }}
          content={() => <Dashboard />}
        />
      </TabItemsDirective>
    </TabComponent>
  );
};
export default ControlCenter;
